const apiUrl = process.env.REACT_APP_API_ENDPOINT;

export const showLastEvents = async (props, state) => {
  const { token, organizationId } = props;

  const { page = 0 } = state;

  let elasticQuery = {
    elasticSearchQuery: {
      bool: {
        must: [
          // Give us assets from this organization
          {
            term: {
              current_owner_id: organizationId,
            },
          },

          // No assets that are from batches
          {
            bool: {
              must_not: [
                {
                  exists: {
                    field: "batch_id",
                  },
                },
              ],
            },
          }
        ],
        must_not: [
          // No devices
          {
            terms: {
              // If the user is on the Inventory Snapshot page, then we do not need
              // to exclude this
              asset_mode: ["Device"],
            },
          },
        ],
        should: [

          // Should be an Inventory asset
          {
            term: {
              asset_mode: "Inventory",
            },
          },

          // Should be a Container asset
          {
            term: {
              asset_mode: "Container",
            },
          }
        ],
        minimum_should_match: 1
      },
    },
    limit: 1000,
    range: {},
    page,
    sort: "time_of_log DESC",
  };

  const results = await fetch(`${apiUrl}assets/search?includeConsoleExtras=true`, {
    method: "POST",
    headers: {
      "auth-token": token,
      "Content-Type": "application/json",
    },
    // body: JSON.stringify(elasticQuery),
    body: JSON.stringify(elasticQuery),
  })
    .then((response) => response.json())
    .then((json) => {
      // Map latitude/longitude - prioritize event-specific lat/long from propertiesMap
      // over root level (which may be facility coordinates)
      if (json.assets && json.assets.length > 0) {
        // DEBUG: Log lat/long sources for first asset
        const sample = json.assets[0];
        console.log("=== LAT/LONG DEBUG ===");
        console.log("Tag:", sample.tag);
        console.log("Root latitude:", sample.latitude);
        console.log("Root longitude:", sample.longitude);
        console.log("propertiesMap.latitude:", sample.propertiesMap?.latitude);
        console.log("propertiesMap.longitude:", sample.propertiesMap?.longitude);
        console.log("facility:", sample.facility);
        console.log("=== END DEBUG ===");
        
        json.assets = json.assets.map((asset) => {
          // Priority: propertiesMap (event GPS) > root level
          const latitude = asset.propertiesMap?.latitude || 
            asset.latitude || 
            null;
          const longitude = asset.propertiesMap?.longitude || 
            asset.longitude || 
            null;
          
          return {
            ...asset,
            latitude: latitude ? parseFloat(latitude) : null,
            longitude: longitude ? parseFloat(longitude) : null,
          };
        });
      }
      return json;
    })
    .catch((err) => {
      console.log(err);
      console.log(elasticQuery);
      return {
        error: "Failed to fetch data, please contact system administrator.",
      };
    });
  return results;
};

export const saveFilterSettings = async (props, filters) => {
  const { token, appUserId } = props;
  const payload = {
    propertiesMap: {
      inventoryStatusTableSettings: filters,
    },
  };
  const results = await fetch(`${apiUrl}appUsers/${appUserId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
    body: JSON.stringify(payload),
  })
    .then((results) => results.json())
    .then((results) => results)
    .catch((err) => {
      console.log(err);
      console.log(payload);
      return {
        error: "Failed to save settings, please contact system administrator.",
      };
    });

  return results;
};

export const retrieveParentIds = async (props) => {
  const { token } = props;
  const results = await fetch(`${apiUrl}assets/assetParents?includeConsoleExtras=true`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
  })
    .then((results) => results.json())
    .then((results) => {
      return results;
    });

  return results;
};

export const inventory = {
  retrieveParentIds,
  saveFilterSettings,
  showLastEvents,
};
